export const forYouItems: string[] = [
  'Vous enseignez la musique en français',
  'Vous souhaitez structurer votre préparation',
  'Vous cherchez des supports à adapter à vos élèves',
  'Vous voulez varier écoute, pratique et création',
]

export const notForYouItems: string[] = [
  'Une formation diplômante',
  'Des cours particuliers personnalisés',
  'Un pack de livres et d’instruments physiques',
  'Une certification de conformité à tous les programmes nationaux',
]
